import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import ReactHtmlParser from "react-html-parser";
import video from "../assets/ECB_BIRD_2023.mp4";
import styles from "../css/ProjectDefinitionStyles";

@inject("updateBirdContentStore")
@observer
export default class ProjectDefinitionPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: 1,
    };
    this.sectionRefs = {};
    this.observers = {};
    this.visibleSections = {}; // Keep track of visible sections
  }

  async componentDidMount() {
    const store = this.props.updateBirdContentStore;
    await store.fetchHTMLDataFromBackend();
    this.observeSections();
  }

  componentWillUnmount() {
    this.unobserveSections();
  }

  setSelectedValue = (value) => {
    this.setState({ selectedValue: value });
  };

  scrollTo = (tableName) => {
    const element = document.getElementById(tableName + "-scroll");
    if (element) {
      element.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  };

  observeSections() {
    const store = this.props.updateBirdContentStore;
    if (store.getHtmlValuesFromBackend) {
      Object.keys(store.getHtmlValuesFromBackend).forEach((key) => {
        const ref = this.sectionRefs[key];
        if (ref) {
          this.observers[key] = new IntersectionObserver(
            (entries) => {
              this.handleIntersection(entries);
            },
            { rootMargin: "50px" }
          );
          this.observers[key].observe(ref);
        }
      });
    }
  }

  unobserveSections() {
    Object.keys(this.observers).forEach((key) => {
      if (this.observers[key]) {
        this.observers[key].disconnect();
      }
    });
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      const key = entry.target.id.split("-")[0];
      if (entry.isIntersecting) {
        this.visibleSections[key] = entry.target.getBoundingClientRect().top;
      } else {
        delete this.visibleSections[key];
      }
    });

    if (Object.keys(this.visibleSections).length > 0) {
      const visibleKeys = Object.keys(this.visibleSections);
      const highestSection = visibleKeys.reduce((acc, key) => {
        if (this.visibleSections[key] < this.visibleSections[acc]) {
          return key;
        }
        return acc;
      }, visibleKeys[0]);

      this.setSelectedValue(highestSection);
    }
  }

  render() {
    const store = this.props.updateBirdContentStore;

    return (
      <React.Fragment>
        <div style={styles.ProjectDefinitionContainer}>
          <div style={styles.ProjectDefinitionLeftSideContainer}>
            <div
              style={{ ...styles.ProjectTitle, cursor: "pointer" }}
              onClick={() => {
                this.scrollTo("BIRD project");
              }}
            >
              About BIRD
            </div>
            <Pins
              pinShown={true}
              scrollTo={this.scrollTo}
              selectedValue={this.state.selectedValue}
              setSelectedValue={this.setSelectedValue}
              store={this.props.updateBirdContentStore}
            />
          </div>

          <div style={styles.ContentContainer}>
            {store.getHtmlValuesFromBackend
              ? Object.entries(store.getHtmlValuesFromBackend).map(([k, v]) => {
                  return (
                    <div key={k}>
                      <h1
                        id={k + "-scroll"}
                        ref={(el) => (this.sectionRefs[k] = el)}
                      >
                        {k}
                      </h1>
                      {k === "BIRD project" && (
                        <div>
                          <video width="100%" height="auto" controls>
                            <source src={video} type="video/mp4" />
                          </video>
                        </div>
                      )}
                      {ReactHtmlParser(v.details)}
                    </div>
                  );
                })
              : null}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const Pins = ({
  pinShown,
  selectedValue,
  setSelectedValue,
  scrollTo,
  store,
}) => {
  const getTopicList = () => {
    const test = store.getHtmlValuesFromBackend
      ? Object.entries(store.getHtmlValuesFromBackend).map(([k, v]) => {
          return {
            id: k,
            title: k,
          };
        })
      : null;
    return test;
  };
  const topicsList = getTopicList();

  const handleClick = (value) => {
    setSelectedValue(value);
    scrollTo(value);
  };

  return (
    <>
      {pinShown ? (
        <div style={styles.PinsContainer}>
          {topicsList.map((item, index) => (
            <div
              style={styles.PinsAlignement}
              id={item.id}
              key={index}
              onClick={() => handleClick(item.id)}
            >
              <div
                id={item.id}
                style={
                  selectedValue === item.id
                    ? styles.selected
                    : styles.unselected
                }
              ></div>
              <div
                id={item.id}
                style={
                  selectedValue === item.id
                    ? styles.textSelected
                    : styles.textUnselected
                }
              >
                {item.title}
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </>
  );
};
